/* layal-listicle.js : « Le guide Layal » (sections/layal-listicle.liquid), chargé par cette section seulement.
 *
 * 1. Barre fixe (téléphone, voir layal-listicle.css) : visible une fois le repère passé (fin du 3e geste par défaut,
 *    [data-ll-repere-barre]), masquée tant que le bloc Produit ou la Conclusion ([data-ll-masque-barre]) est à
 *    l'écran. IntersectionObserver uniquement, aucun écouteur de défilement. Sans IntersectionObserver ou sans
 *    script : pas de barre (les boutons de la page restent). Barre ouverte : classe ll-barre-ouverte sur <html>
 *    (le bouton WhatsApp passe au-dessus) et hauteur dans --ll-barre-h.
 * 2. Clics vers la fiche ([data-ll-clic]) : Shopify.analytics.publish('layal_guide_clic', { position }) si
 *    Shopify.analytics existe ; jamais d'erreur ni de blocage de la navigation sinon.
 */
(function () {
  "use strict";

  var POSITIONS = ["entete", "geste10", "offre-solo", "offre-duo", "offre-trio", "conclusion", "barre"];

  function publier(position) {
    if (POSITIONS.indexOf(position) === -1) return;
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === "function") {
        analytics.publish("layal_guide_clic", { position: position });
      }
    } catch (e) {
      /* le suivi ne doit jamais empêcher d'aller sur la fiche */
    }
  }

  document.addEventListener("click", function (e) {
    var lien = e.target && e.target.closest ? e.target.closest("[data-ll-clic]") : null;
    if (lien) publier(lien.getAttribute("data-ll-clic"));
  });

  function initGuide(racine) {
    if (racine._llArreter) racine._llArreter();
    var barre = racine.querySelector("[data-ll-barre]");
    var repere = racine.querySelector("[data-ll-repere-barre]");
    var html = document.documentElement;
    if (!barre) return;
    if (!repere || !("IntersectionObserver" in window)) {
      barre.hidden = true;
      return;
    }

    var masques = Array.prototype.slice.call(racine.querySelectorAll("[data-ll-masque-barre]"));
    var aEcran = masques.map(function () { return false; });
    var passe = false;
    var visible = null;

    function appliquer() {
      var montrer = passe && aEcran.indexOf(true) === -1;
      if (montrer === visible) return;
      visible = montrer;
      barre.classList.toggle("est-visible", montrer);
      barre.setAttribute("aria-hidden", montrer ? "false" : "true");
      if ("inert" in barre) barre.inert = !montrer;
      html.classList.toggle("ll-barre-ouverte", montrer);
      if (montrer) html.style.setProperty("--ll-barre-h", barre.offsetHeight + "px");
    }

    // Repère passé : il est entré par le bas de l'écran (ou se trouve déjà au-dessus).
    var suiviRepere = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        var hauteur = en.rootBounds ? en.rootBounds.height : window.innerHeight;
        passe = en.isIntersecting || en.boundingClientRect.top < hauteur;
      });
      appliquer();
    });
    var suiviMasques = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        var i = masques.indexOf(en.target);
        if (i !== -1) aEcran[i] = en.isIntersecting;
      });
      appliquer();
    });

    barre.hidden = false;
    barre.setAttribute("aria-hidden", "true");
    if ("inert" in barre) barre.inert = true;
    suiviRepere.observe(repere);
    masques.forEach(function (el) { suiviMasques.observe(el); });

    racine._llArreter = function () {
      suiviRepere.disconnect();
      suiviMasques.disconnect();
      html.classList.remove("ll-barre-ouverte");
      racine._llArreter = null;
    };
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-ll-guide]"), initGuide);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();

  // Éditeur de thème : section rechargée ou retirée.
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-ll-guide]"), initGuide);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-ll-guide]"), function (r) {
      if (r._llArreter) r._llArreter();
    });
  });
})();
